import { memo } from "react";
import { localizedPhoneDisplayType } from "./localizedTypes";
import { localizedPhoneNumber } from "./localizationUtils";

/**
 * LocalizedPhoneDisplay is a component that displays a phone number with
 * localized way of presenting it, including area and country codes
 * @param phoneNumber   {string}    - phone number to display
 * @param locale        {string}    - current localization code
 * @param international {boolean}   - if the phone number should be displayed
 *                                    in interna+ tional format
 * @param showError     {boolean}   - if the phone number is illegal,
 *                                    should error message be displayed
 * @returns span element with localized phone number, optionally formatted
 * as international with country code.
 */

const LocalizedPhoneDisplay = ({
  phoneNumber,
  locale = "en-US",
  international = false,
  ...props
}: localizedPhoneDisplayType) => {
  const formattedPhone = localizedPhoneNumber(
    phoneNumber,
    locale,
    international
  );
  return <span {...props}>{`${formattedPhone}`}</span>;
};

export default memo(LocalizedPhoneDisplay);
